import {
	reRegionConstants
}from './constants'
import actions from '../../../actions'

const initialState =
{
	isSending   : false,
	paged       : {},
	pagedAudit  : null,
	countAudit  : null,
	list        : [],
	listByRoles : {},
	changed     : null
}

export default function (state = initialState, action){
	switch (action.type){
		case reRegionConstants.GetPaged.REQUEST:
		case reRegionConstants.GetPagedAll.REQUEST:
		case reRegionConstants.GetList.REQUEST:
		case reRegionConstants.GetListForRoles.REQUEST:
		case reRegionConstants.Create.REQUEST:
		case reRegionConstants.Delete.REQUEST:
		case reRegionConstants.Restore.REQUEST:
		case reRegionConstants.Update.REQUEST:
		case reRegionConstants.GetPagedAudit.REQUEST:
			return {
				...state,
				isSending : true,
				changed   : null
			}
		case reRegionConstants.GetPaged.FAILURE:
		case reRegionConstants.GetPagedAudit.FAILURE:
		case reRegionConstants.GetPagedAll.FAILURE:
		case reRegionConstants.GetList.FAILURE:
		case reRegionConstants.GetListForRoles.FAILURE:
		case reRegionConstants.Create.FAILURE:
		case reRegionConstants.Delete.FAILURE:
		case reRegionConstants.Restore.FAILURE:
		case reRegionConstants.Update.FAILURE:
			return {
				...state,
				isSending : false,
				error     : action.payload,
				changed   : null
			}
		case reRegionConstants.GetPaged.SUCCESS:
		case reRegionConstants.GetPagedAll.SUCCESS:
			return {
				...state,
				isSending : false,
				paged     : action.payload.result
			}
		case reRegionConstants.GetPagedAudit.SUCCESS:
			return {
				...state,
				isSending  : false,
				pagedAudit : action.payload.result.items,
				countAudit : action.payload.result.count
			}
		case reRegionConstants.GetList.SUCCESS:
			return {
				...state,
				isSending : false,
				list      : action.payload.result
			}

		case reRegionConstants.GetListForRoles.SUCCESS:
			return {
				...state,
				isSending   : false,
				listByRoles : action.payload.result
			}

		case reRegionConstants.Create.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.create : null
			}
		case reRegionConstants.Delete.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.delete : null
			}
		case reRegionConstants.Update.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.update : null
			}
		case reRegionConstants.Restore.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.restore : null
			}
		case reRegionConstants.CLEAR:
			return {
				...state,
				changed     : null,
				isSending   : false,
				paged       : {},
				pagedAudit  : null,
				list        : [],
				listByRoles : {},
				countAudit  : null
			}
		default:
			return state
	}
}